






















import Vue from 'vue';
import { IQuickLink } from '../../../../common/interfaces/frontpage.interface';
import ArrowIcon from '../../../icons/ArrowIcon.vue';

export default Vue.extend({
  name: `QuickLink`,
  components: { ArrowIcon },
  props: {
    icon: {
      required: true,
      type: String,
    },
    quickLink: {
      required: true,
      type: Object as () => IQuickLink,
    },
  },
});
